var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info-wrapper editInfo-wrap"
  }, [_c('h2', [_vm._v("Display Setting")]), _c('p', [_vm._v("Enter and Update all your Display Setting here.")]), _c('div', {
    staticClass: "information-form mt-4"
  }, [_c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          ref: "downlineRepDisplaySettingContainer",
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return handleSubmit(_vm.updateInfo);
            }
          }
        }, [_c('div', {
          staticClass: "form-group row"
        }, [_c('span', {
          staticClass: "col-xxl-4 col-xl-5 col-lg-6 col-md-6 mb-3"
        }, [_c('input-text', {
          attrs: {
            "rules": {
              required: false,
              digits: 10
            },
            "labelFor": "display_phone",
            "labelName": "Display Phone ",
            "vmodel": _vm.form.display_phone,
            "formGroupClass": "",
            "inputType": "text",
            "maxlength": "10",
            "inputmode": "numeric",
            "pattern": "\\d*"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "display_phone", $event);
            }
          },
          nativeOn: {
            "input": function input($event) {
              return _vm.enforceDigitLimit.apply(null, arguments);
            },
            "keypress": function keypress($event) {
              return _vm.onlyAllowDigits.apply(null, arguments);
            }
          }
        }), _c('div', {
          staticClass: "mt-3 row justify-content-between validation-row"
        }, [_vm.showOtpSectionPhone ? _c('span', {
          staticClass: "validate-btn col-md-5 col-sm-6 d-flex rep-display-otp-validation"
        }, [_c('a', {
          staticClass: "validate-via-otp-link ",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.openOtpModal('phone');
            }
          }
        }, [_vm._v(" TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR PHONE. ")])]) : _vm._e()]), _vm.phoneMsg ? _c('div', {
          staticClass: "message-container mt-2"
        }, [_c('div', {
          class: ['validate-message', "".concat(_vm.phoneValidationMessage.type)]
        }, [_c('div', {
          class: ['message-indicator', "".concat(_vm.phoneValidationMessage.type, "-indicator")]
        }), _c('span', {
          staticClass: "message-text"
        }, [_c('strong', {
          class: "".concat(_vm.phoneValidationMessage.type, "-text")
        }, [_vm._v(_vm._s(_vm.phoneValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.phoneValidationMessage.message) + " ")]), _c('button', {
          staticClass: "close-btn",
          attrs: {
            "type": "button",
            "onclick": "this.parentElement.style.display='none';"
          }
        }, [_c('span', {
          attrs: {
            "aria-hidden": "true"
          }
        }, [_vm._v("×")])])])]) : _vm._e()], 1), _c('span', {
          staticClass: "col-xxl-4 col-xl-5 col-lg-6 col-md-6 mb-3"
        }, [_c('input-text', {
          attrs: {
            "rules": {
              required: false,
              email: true
            },
            "labelFor": "display_email",
            "labelName": "Display Email ",
            "vmodel": _vm.form.display_email,
            "formGroupClass": ""
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "display_email", $event);
            }
          }
        }), _c('div', {
          staticClass: "mt-3 row justify-content-between validation-row"
        }, [_vm.showOtpSectionEmail ? _c('span', {
          staticClass: "validate-btn col-md-5 col-sm-6 d-flex rep-display-otp-validation"
        }, [_c('a', {
          staticClass: "validate-via-otp-link ",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.openOtpModal('email');
            }
          }
        }, [_vm._v(" TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR EMAIL. ")])]) : _vm._e()]), _vm.emailMsg ? _c('div', {
          staticClass: "message-container mt-2"
        }, [_c('div', {
          class: ['validate-message', "".concat(_vm.emailValidationMessage.type)]
        }, [_c('div', {
          class: ['message-indicator', "".concat(_vm.emailValidationMessage.type, "-indicator")]
        }), _c('span', {
          staticClass: "message-text"
        }, [_c('strong', {
          class: "".concat(_vm.emailValidationMessage.type, "-text")
        }, [_vm._v(_vm._s(_vm.emailValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.emailValidationMessage.message) + " ")]), _c('button', {
          staticClass: "close-btn",
          attrs: {
            "type": "button",
            "onclick": "this.parentElement.style.display='none';"
          }
        }, [_c('span', {
          attrs: {
            "aria-hidden": "true"
          }
        }, [_vm._v("×")])])])]) : _vm._e()], 1)]), _c('div', {
          staticClass: "form-group row"
        }, [_c('input-text', {
          attrs: {
            "rules": {
              required: false
            },
            "labelFor": "tagline",
            "labelName": "Tagline ",
            "vmodel": _vm.form.tagline,
            "formGroupClass": "col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-3"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "tagline", $event);
            }
          }
        }), _c('input-text', {
          attrs: {
            "rules": {
              required: false
            },
            "labelFor": "group_appointment_url",
            "labelName": "Appointment Link",
            "vmodel": _vm.form.appointment_url,
            "formGroupClass": "col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-3"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "appointment_url", $event);
            }
          }
        }), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-xxl-6 mt-3 my-profile-bio"
        }, [_c('div', {
          staticClass: "profileInfo-block"
        }, [_c('h6', [_vm._v("Bio")]), _c('div', {
          staticClass: "form-group mb-3"
        }, [_c('textarea', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.form.display_about_page,
            expression: "form.display_about_page"
          }],
          staticClass: "profileInfo-field form-control",
          attrs: {
            "placeholder": "Enter your Bio here...",
            "rows": "7"
          },
          domProps: {
            "value": _vm.form.display_about_page
          },
          on: {
            "input": function input($event) {
              if ($event.target.composing) { return; }

              _vm.$set(_vm.form, "display_about_page", $event.target.value);
            }
          }
        })])])])])], 1), _vm.display_setting_image ? _c('div', {
          staticClass: "form-group row"
        }, [_c('div', {
          staticClass: "col-xxl-6 col-xl-6 col-lg-6 col-md-12 mb-4"
        }, [_c('figure', [_vm._v("Where can I see this information?")]), _c('img', {
          staticClass: "img-fluid",
          attrs: {
            "src": _vm.display_setting_image
          }
        })])]) : _vm._e(), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-xxl-3 col-xl-3 col-lg-3 col-md-6"
        }, [_c('button', {
          staticClass: "univ-btn",
          attrs: {
            "type": "submit"
          }
        }, [_vm._v(" " + _vm._s(_vm.isUpdate ? "Updating..." : "Update") + " ")])])])]), _vm.showOtpModal ? _c('employer-email-verification', {
          attrs: {
            "identifier": _vm.contactInfo,
            "identifierTypeText": _vm.otpType
          },
          on: {
            "save": _vm.handleVerificationResult,
            "close": _vm.closeOtpModal
          },
          model: {
            value: _vm.showOtpModal,
            callback: function callback($$v) {
              _vm.showOtpModal = $$v;
            },
            expression: "showOtpModal"
          }
        }) : _vm._e()];
      }
    }])
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }